import * as React from "react";
import JSONTree from 'react-json-tree';
import ObjectPath from "object-path";

import FilterCheck from "./FilterCheck";
import MetamodelStore from '../../resources/data/MetamodelStore';
import Config from '../../Config';

/**
 * Tree of model types containing lists with checkboxes representing their objects
 */
export default class FilterCheckObjTree extends FilterCheck
{
    aTreeTheme = {
        base00: '#FFFFFF',
        base01: '#000000',
        base02: '#000000',
        base03: '#000000',
        base04: '#000000',
        base05: '#000000',
        base06: '#000000',
        base07: '#000000',
        base08: '#000000',
        base09: '#000000',
        base0A: '#000000',
        base0B: '#000000',
        base0C: '#000000',
        base0D: '#000000',
        base0E: '#000000',
        base0F: '#000000'
    };

    render()
    {
        const { aAddExtraData, onChangeCallback } = this.props;
        const aJsonTree = JSON.parse(JSON.stringify(this.props.aJsonTree));

        return (
            <div>
                { aJsonTree &&
                    <JSONTree
                        data={aJsonTree}
                        hideRoot={true}
                        theme={{
                            extend: this.aTreeTheme,
                            arrowSign: {
                                fontFamily: "Segoe UI Symbol, sansSerif",
                                color: "#AFAFAF"
                            },
                            tree: {
                                fontSize: "12px"
                            }
                        }}
                        invertTheme={false}
                        getItemString={() => { return null }}
                        postprocessValue={(value) =>
                        {
                            if (Object.hasOwnProperty.call(value, 'id_group'))
                            {
                                delete value['id_group'];
                            }
                            return value;
                        }}
                        labelRenderer={(keyPath, nodeType) =>
                        {
                            keyPath.reverse();
                            const aInitData = ObjectPath.get(this.props.aJsonTree, keyPath);
                            keyPath.reverse();
                            if (aInitData && Object.hasOwnProperty.call(aInitData, 'id_group'))
                            {
                                try
                                {
                                    var sIcon = MetamodelStore.getInstance().getIcon(aInitData.id_group);
                                } catch (err)
                                {
                                    console.warn(err);
                                }
                            }

                            // show checkbox for the last item
                            if (nodeType === 'String')
                            {
                                var aObjData;
                                try
                                {
                                    aObjData = MetamodelStore.getInstance().getMetaObjectType(aInitData);
                                } catch (err)
                                {
                                    console.error(err);
                                    return null;
                                }
                                const sName = Object.hasOwnProperty.call(aObjData, 'sName') ? aObjData.sName : null;
                                const sID = Object.hasOwnProperty.call(aObjData, 'id') ? aObjData.id : null;
                                const sLabel = Config.getLangName(aObjData);
                                var bChecked = false;
                                if (aAddExtraData)
                                {
                                    if (undefined != this.state.aSelectedItems.find(aItem => (Object.hasOwnProperty.call(aItem, 'name') && aItem.name === sName)))
                                    {
                                        bChecked = true;
                                    }
                                } else
                                {
                                    if (undefined != this.state.aSelectedItems.find(aItem => aItem === sName))
                                    {
                                        bChecked = true;
                                    }
                                }

                                return (
                                    <div>
                                        <input
                                            type="checkbox"
                                            checked={bChecked}
                                            onChange={(aEvent) =>
                                            {
                                                if (aAddExtraData && Object.hasOwnProperty.call(aAddExtraData, 'id') && aAddExtraData.id && sID)
                                                {
                                                    this.handleChange(aEvent, {
                                                        id: sID,
                                                    });
                                                } else
                                                {
                                                    this.handleChange(aEvent);
                                                }

                                                if (onChangeCallback && typeof onChangeCallback === 'function')
                                                {
                                                    onChangeCallback();
                                                }
                                            }}
                                            name={sName}
                                        />

                                        <label>
                                            {sLabel}
                                        </label>
                                    </div>
                                );
                            }
                            
                            return (
                                <div>
                                    {sIcon && <img src={"data:image/png;base64," +sIcon} />}
                                    {' '}
                                    <span>{keyPath[0]}</span>
                                </div>
                            );
                        }}
                        valueRenderer={() =>
                        {
                            return null;
                        }}
                    />}
            </div>
        );
    }
}
